module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_5012.2e1f4aa6.png";